import { render, staticRenderFns } from "./editOrderLog.vue?vue&type=template&id=b192128c&scoped=true"
import script from "./editOrderLog.vue?vue&type=script&lang=js"
export * from "./editOrderLog.vue?vue&type=script&lang=js"
import style0 from "./editOrderLog.vue?vue&type=style&index=0&id=b192128c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b192128c",
  null
  
)

export default component.exports